import Button from "../../../../../utils/component/button/button.index";
import folderIcon from "../../../../../assets/images/fileManager/Folder.svg";
import { ReactComponent as ArrowLeft } from "../../../../../assets/images/icons/arrow-left.svg";
import { ReactComponent as ArrowRight } from "../../../../../assets/images/icons/ArrowRight.svg";
import { ReactComponent as Times } from "../../../../../assets/images/sidebar/Times.svg";
import { useEffect, useState } from "react";
import { isFolder, searchUrlToObject } from "../../../../../scripts/helpers";
import { ResourceType } from "../../../../../interfaces/general";
import { ButtonSize, ButtonType } from "../../../../../utils/component/button/button.interface";
import { getObject, getObjects } from "../../../../../utils/component/fileManagers/fileManager.function";
import { FolderLocationModalInterface } from "./folderLocationModal.interface";
import Dialog from "../../../../../utils/component/dialog/dialog.index";
import { DialogSize } from "../../../../../utils/component/dialog/dialog.interface";

const FolderLocationModal = ({
    showFolderLocationModal,
    setShowFolderLocationModal,
    handleGetFolderLocation,
    isModal = true
}: FolderLocationModalInterface) => {
    const [resources, setResources] = useState<ResourceType[] | undefined>(undefined);
    const [parent, setParent] = useState<number | undefined>(undefined);
    const [currentResource, setCurrentResource] = useState<ResourceType | null>(null);

    useEffect(() => {
        const params = searchUrlToObject();
        delete params["pageType"];
        if (params.parent_id) {
            setParent(Number(params.parent_id));
        } else {
            setParent(undefined);
        }
    }, [showFolderLocationModal]);

    useEffect(() => {
        if (showFolderLocationModal) {
            if (parent) {
                getObject(parent).then((data) => {
                    setCurrentResource(data);
                });
                getResources();
            } else {
                setCurrentResource(null);
                getResources();
            }
        }
    }, [parent, showFolderLocationModal]);

    const getResources = () => {
        setResources(undefined);
        getObjects(parent).then((data) => {
            const folders = data.filter((result: ResourceType) => isFolder(result) === true);
            setResources(folders);
        });
    };

    const handleBackClick = () => (currentResource?.parent ? setParent(currentResource.parent) : setParent(undefined));

    const browse = (
        <div className={`flex flex-col rounded-[20px] overflow-hidden ${isModal ? "h-full" : "max-h-[400px] h-[400px]"}`}>
            <header className="flex items-center bg-[#FBFBFB] !mb-0 p-4">
                <Button
                    onClick={handleBackClick}
                    icon={<ArrowLeft className="stroke-transparent !fill-[#A0A3BD] ml-4" />}
                    size={ButtonSize.SM}
                    className="!p-0"
                    type={ButtonType.TEXT}
                    autoFocus={false}
                />
                <p className="w-[90%] whitespace-nowrap overflow-hidden text-ellipsis">{parent ? currentResource?.name : "فایل‌های من"}</p>
                {isModal && <Times onClick={() => setShowFolderLocationModal(false)} className="cursor-pointer mr-auto" />}
            </header>
            <div className="flex-1 h-full overflow-auto no-scrollbar">
                {!resources &&
                    parent !== null &&
                    Array.from(Array(4).keys()).map((item, index) => (
                        <div className="flex items-center gap-4 px-6 py-4" key={index}>
                            <div className="skeleton w-[40px] h-[40px]" />
                            <div className="w-[100px] h-[20px] skeleton" />
                        </div>
                    ))}

                {parent !== null && (
                    <div className="h-full overflow-auto no-scrollbar">
                        {resources && resources.length > 0 ? (
                            resources.map((folder: ResourceType) => (
                                <div
                                    key={folder.id}
                                    className={`flex items-center justify-between gap-4 px-4 py-4 cursor-pointer hover:bg-primary-50 m-0`}
                                    onClick={() => setParent(folder.id)}
                                >
                                    <img src={folderIcon} alt="folder" />
                                    <h3 className="flex-1 truncate">{folder.name}</h3>
                                    <ArrowRight className="rotate-180" />
                                </div>
                            ))
                        ) : (
                            <h4 className="text-center leading-[300px]">در این پوشه هیچ پوشه‌ای وجود ندارد!</h4>
                        )}
                    </div>
                )}
            </div>

            <div className="p-4 bg-[#FBFBFB]">
                <Button
                    text="انتخاب فایل"
                    size={ButtonSize.SM}
                    className="mr-auto w-[212px]"
                    autoFocus={true}
                    onClick={() => {
                        handleGetFolderLocation(currentResource?.id, currentResource?.name);
                        setShowFolderLocationModal(false);
                    }}
                />
            </div>
        </div>
    );

    return (
        <>
            {isModal ? (
                <Dialog
                    status={showFolderLocationModal}
                    closeButton={false}
                    onClose={() => {
                        setShowFolderLocationModal(false);
                    }}
                    className="!max-h-[500px] !h-full"
                    size={DialogSize.MD}
                >
                    {browse}
                </Dialog>
            ) : (
                browse
            )}
        </>
    );
};

export default FolderLocationModal;
